import { render, staticRenderFns } from "./manualGoodsList.vue?vue&type=template&id=8d7ffce4&scoped=true"
import script from "./manualGoodsList.vue?vue&type=script&lang=js"
export * from "./manualGoodsList.vue?vue&type=script&lang=js"
import style0 from "./manualGoodsList.vue?vue&type=style&index=0&id=8d7ffce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7ffce4",
  null
  
)

export default component.exports